export default __webpack_public_path__ + "static/media/yacht.3007ff96.png";